import {
  addDoc,
  deleteDoc,
  doc,
  FirestoreError,
  orderBy,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { firestore } from "..";
import UserDataStore from "../../../store/UserDataStore";
import { scenarioConverter } from "../converters/scenarioConverter";
import { CollectionName } from "../types/collections.types";
import { Scenario } from "../types/scenario.types";
import { createCollection, subscribeCollection } from "./collectionService";

const scenarioCollection = createCollection<Scenario>(CollectionName.SCENARIOS);

export const subscribeScenarios = (
  onNewSnapshot: (scenarios: Scenario[]) => void,
  onError: (err: FirestoreError) => void
) => {
  const user = UserDataStore.currentUser;
  if (!user?.userId) return;
  const scenarioQuery = query(
    scenarioCollection,
    where("userId", "==", user.userId),
    orderBy("title", "asc")
  ).withConverter(scenarioConverter);
  return subscribeCollection<Scenario>(scenarioQuery, onNewSnapshot, onError);
};

export const addScenario = async (scenario: Omit<Scenario, "id">) => {
  try {
    await addDoc(scenarioCollection, scenario);
  } catch (e) {
    console.error(e);
  }
};

export const updateScenario = async (
  scenarioId: string,
  scenarioParamsToUpdate: Partial<Scenario>
) => {
  const scenarioRef = doc(
    firestore,
    CollectionName.SCENARIOS,
    scenarioId
  ).withConverter(scenarioConverter);
  return await setDoc(scenarioRef, scenarioParamsToUpdate, { merge: true });
};

export const deleteScenario = async (scenarioId: string) => {
  const scenarioRef = doc(firestore, CollectionName.SCENARIOS, scenarioId);
  return await deleteDoc(scenarioRef);
};

export default scenarioCollection;
